var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 520 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 520
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_3",
    "data-name": "Web 1920 \\u2013 3",
    clipPath: "url(#clip-Web_1920_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M96.4,5.2q22.8,0,38.8-18.8A77.262,77.262,0,0,0,152-54q2.8-23.2,10.8-84,9.2-66.8,25.2-66.8,22.4,0,76,121.2,10.8,24.8,24.4,51.2,10,18.8,26.4,18.8,13.6,0,23.2-5.2,12.8-6,12.8-18.8,0-39.2,12.8-117.4t12.8-117.8q0-11.6-10.6-19.4a37.457,37.457,0,0,0-22.6-7.8,20.81,20.81,0,0,0-6.4.8q-8.4,2.8-11.2,12.8a358.189,358.189,0,0,0-8,36.8l-7.2,37.2q-4.8,23.6-12.8,69.2-10-16.4-39.2-51.2-22.8-27.6-35.2-57.2-10.8-26.8-27.2-26.8-21.6,0-42.8,32-11.6,18-24,53.2-13.6,38.4-22.4,53.6Q90-216,70.8-350.8,68-373.2,42-373.2q-24.4,0-24.4,22,0,57.6,20.8,176,5.6,30,17.2,102.8Q56.8-59.6,62-24.8,67.2,5.2,96.4,5.2Z",
    transform: "translate(62 446)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7eb93750a51d16d7c930691942a07af5.svg";
export { ForwardRef as ReactComponent };